import { IGameData, HexGridType } from 'js/bubbleCore/types';
import { convertHexLimitsToSpaceLimits } from 'js/bubbleCore/utils/convertHexLimitsToSpaceLimits';
import { convertRectangleToSpace } from 'js/bubbleCore/utils/convertRectangleToSpace';
import { ISpace, IRectangle } from 'framework/utils/math-utils';
import { getHexSize } from 'js/bubbleCore/utils/getHexSize';
import { RandomDataGenerator } from 'framework/RandomDataGenerator/RandomDataGenerator';
import { BubbleFactory } from 'js/bubbleCore/bubbles/BubbleFactory';
import { parsePopOutSpace } from 'js/bubbleCore/levelParser/parsePopOutSpace';
import { parseGrid } from 'js/bubbleCore/levelParser/parseGrid';
import { parseShooter } from 'js/bubbleCore/levelParser/parseShooter';
import { IColorConfig } from 'js/bubbleCore/types';

export interface ILevelData {
  config: ILevelDataGameConfig;
  grid: ILevelDataGrid;
  popOutSpace: ILevelDataPopOutSpace;
  shooter: ILevelDataShooter;
}

interface ILevelDataGameConfig {
  fireEvery: number;
  availableColors: IColorConfig[],
}

interface ILevelDataGrid {
  type: HexGridType;
  hexLimits: IRectangle;
  asymetrical: boolean;
  rowsToFill: number;
  scrollSpeed: number;
  fillScrollSpeed: number;
  scrollFill: number;
  deathLineY: number;
}

// normalize for field
export interface ILevelDataPointZone {
  x: number;
  score: number;
}

interface ILevelDataShooter {
  bubbleSpeed: number;
  positionY: number;
  angleLimitDeg: number;
}

interface ILevelDataPopOutSpace {
  gravity: number;
  pointZones: ILevelDataPointZone[];
  popOutVelRange: ISpace;
  bouncers: {
    y: number;
    width: number;
    height: number;
  };
  pointZonesY: number;
}

export function parseLevel(
  rnd: RandomDataGenerator,
  factory: BubbleFactory,
  levelData: ILevelData,
): IGameData {
  const type = levelData.grid.type;

  const spaceLimits = convertRectangleToSpace(
    convertHexLimitsToSpaceLimits(levelData.grid.hexLimits, type)
  );

  return {
    config: {
      fireEvery: levelData.config.fireEvery,
      availableColors: levelData.config.availableColors,
    },
    state: {
      score: 0,
      chain: 0,
      gameOver: false,
      firstShoot: false,
      time: 0,
    },
    shootingSpace: {
      type,
      limits: spaceLimits,
      values: [],
      gravity: 0,
    },
    popOutSpace: parsePopOutSpace(rnd, levelData),
    grid: parseGrid(factory, levelData),
    shooter: parseShooter(factory, levelData),
  };
}

